
import { createRoot } from 'react-dom/client'
import App from './App.tsx'
import './index.css'
import { ThemeProvider } from './components/theme-provider'

// Log authentication state at startup
import { supabase } from './lib/supabase'
supabase.auth.getSession().then(({ data }) => {
  console.log('Initial auth session state:', data.session ? 'Authenticated' : 'Not authenticated')
})

const rootElement = document.getElementById("root")
if (!rootElement) throw new Error('Root element not found')

// Add error boundary to catch and log rendering errors
try {
  console.log("Attempting to render application");
  createRoot(rootElement).render(
    <ThemeProvider defaultTheme="light" storageKey="teenvisor-theme">
      <App />
    </ThemeProvider>
  );
  console.log("Application rendered successfully");
} catch (error) {
  console.error("Error rendering application:", error);
  document.body.innerHTML = '<div style="padding: 20px; font-family: sans-serif;"><h1>Application Error</h1><p>Sorry, there was an error loading the application. Please try refreshing the page.</p></div>';
}
